import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { Auth } from 'aws-amplify'

import api, { createWrappedAsyncThunk } from 'src/api'

export const initialState = {
  user: null,
  featureSwitches: {},
}

const SLICE_NAME = 'auth'

export const fetchUser = createWrappedAsyncThunk(
  `${SLICE_NAME}/fetchUser`,
  arg => api.get('/user/')
)

export const createUser = createWrappedAsyncThunk(
  `${SLICE_NAME}/createUser`,
  params => api.post('/user/', { body: params })
)

export const updateProfile = createWrappedAsyncThunk(
  `${SLICE_NAME}/updateProfile`,
  args => api.patch('/user/', { body: args })
)

export const changePassword = createAsyncThunk(
  `${SLICE_NAME}/changePassword`,
  async ({ oldPassword, newPassword }) => {
    const user = await Auth.currentAuthenticatedUser()
    await Auth.changePassword(user, oldPassword, newPassword)
  }
)

export const getFeatureSwitches = createWrappedAsyncThunk(
  `${SLICE_NAME}/getFeatureSwitches`,
  arg => api.get('/organisation/feature-switch/')
)

const slice = createSlice({
  name: SLICE_NAME,
  initialState,
  extraReducers: {
    [fetchUser.fulfilled]: (state, { payload }) => {
      state.user = payload
      return state
    },
    [getFeatureSwitches.fulfilled]: (state, { payload }) => {
      state.featureSwitches = payload
      return state
    },
    [updateProfile.fulfilled]: (state, { payload }) => {
      state.user = payload
      return state
    },
  },
})

export default slice.reducer
